module.exports = __webpack_public_path__ + "img/4.36b70608.jpg";